import { RouteItem } from '@eastcoal/router/types/route'

import {
  AUDIT_ENTERPRISE_CREATE_PAGE_PATH,
  AUDIT_ENTERPRISE_DETAIL_PAGE_PATH,
  AUDIT_ENTERPRISE_EDIT_PAGE_PATH,
  AUDIT_ENTERPRISE_RESULT_PAGE_PATH
} from './constants/path'

export const enterpriseAuditRoute: RouteItem = {
  title: '企业认证',
  hideInMenu: true,
  children: [
    {
      title: '新增企业认证',
      path: AUDIT_ENTERPRISE_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    },
    {
      title: '编辑企业认证',
      path: AUDIT_ENTERPRISE_EDIT_PAGE_PATH,
      Component: () => import('./Edit')
    },
    {
      title: '企业认证详情',
      path: AUDIT_ENTERPRISE_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    },
    {
      path: AUDIT_ENTERPRISE_RESULT_PAGE_PATH,
      Component: () => import('./Result')
    }
  ]
}
